var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDataLoaded)?_c('s-page',{staticClass:"max-w-2xl"},[_c('inventory-list'),_c('modal-submit-order')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }